/**
 * i18n helpers that delegate to window.wp.i18n — the @wordpress/i18n instance
 * that WordPress controls and injects translations into via wp_set_script_translations().
 *
 * Using window.wp.i18n directly (rather than a bundled copy) ensures that
 * wp.i18n.setLocaleData() calls made by WordPress's inline translation script
 * are visible to our __() calls at render time.
 *
 * Falls back gracefully (returns the original string) when wp.i18n is not
 * available (e.g. local dev outside WordPress, or wp-i18n not enqueued).
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type WpI18nGlobal = Record<string, (...args: any[]) => any>;

function wpI18n(): WpI18nGlobal | undefined {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any)?.wp?.i18n as WpI18nGlobal | undefined;
}

export function __(text: string, domain?: string): string {
  return wpI18n()?.__?.(text, domain) ?? text;
}

export function _n(
  single: string,
  plural: string,
  count: number,
  domain?: string
): string {
  return wpI18n()?._n?.(single, plural, count, domain) ?? (count === 1 ? single : plural);
}

export function _x(text: string, context: string, domain?: string): string {
  return wpI18n()?._x?.(text, context, domain) ?? text;
}

export function sprintf(format: string, ...args: unknown[]): string {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (wpI18n()?.sprintf as any)?.(format, ...args) ?? format;
}

export const TEXT_DOMAIN = "accessibility-widget";
